import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { TableContainer } from "@material-ui/core";

const Container = styled(({props, ...others}) => (
    <TableContainer {...others}/>
))`
    max-height: ${props => props.height ? props.height : 0}px;
`;

const TableContainerWithHeight = ({height, children}) => {
    return (
        <Container height={height}>
            {children}
        </Container>
    );
};

TableContainerWithHeight.propTypes = {
    height: PropTypes.number
};

export default TableContainerWithHeight;
